import {Injectable} from "@angular/core";
import {Subject} from "rxjs/index";


/**
 * Сервис для управления глобальным индикатором загрзки на основе лоадера из `NgxLoadingModule`.
 * @publicApi
 */
@Injectable()
export class DxGlobalWaiterService {
  /**
   * Время задержки запуска индикации в миллисекундах.
   * @name WAITER_START_DELAY
   * @type {number}
   */
  public static WAITER_START_DELAY: number = 100;

  /**
   * Время задержки остановки индикации в миллисекундах.
   * @name WAITER_START_DELAY
   * @type {number}
   */
  public static WAITER_STOP_DELAY: number = 200;

  /**
   * Субъет (наблюдаемое\субьект наблюдения) для состояние индикатора загрузки: показан\скрыт.
   * @name _waiterState
   * @type {Subject<boolean>}
   */
  private _waiterState: Subject<boolean> = new Subject();

  /**
   * Создает инстанс сервиса.
   * @constructor
   */
  constructor() { }

  /**
   * Возвращает состояние индикатора загрузки.
   * @return {boolean} - true (индикатор показывается)\false (индикатор скрыт).
   */
  get waiterState(): Subject<boolean> {
    return this._waiterState;
  }

  /** Запускает индикацию загрузки. */
  public showWaiter(): void {
    this._waiterState.next(true);
  }

  /** Останавливает индикацию загрузки. */
  public hideWaiter(): void {
    this._waiterState.next(false);
  }
}
